import { type IconLibrary } from 'src/components/DynamicIcon/dynamic-icon';
import { LUCIDE_ICONS } from 'src/components/DynamicIcon/lucide-icons';

// Material Symbols name → lucide name, only for nav icons sourced from the DB
// (custom-view picker, folder icons, assignment fallbacks) that can't be
// authored as a lucide name up front. Targets must exist in LUCIDE_ICONS.
const MATERIAL_TO_LUCIDE_NAME: Record<string, string> = {
  inbox: 'inbox',
  all_inbox: 'layers',
  task: 'clipboard-check',
  checklist: 'list-checks',
  home: 'home',
  assignment_ind: 'id-card',
  group_work: 'users',
  insights: 'line-chart',
  priority_high: 'alert-circle',
  schedule_send: 'calendar-clock',
  report: 'alert-octagon',
  analytics: 'bar-chart-3',
  trending_up: 'trending-up',
  trending_flat: 'move-right',
  event_available: 'calendar-check',
  flag: 'flag',
  browse_gallery: 'gallery-horizontal-end',
  deployed_code: 'package',
  hourglass_disabled: 'hourglass',
  support_agent: 'headphones',
  bug_report: 'bug',
  warning_amber: 'alert-triangle',
  report_problem: 'alert-triangle',
  task_alt: 'check-circle',
  stars: 'sparkles',
  label_important: 'tag',
  event_note: 'calendar-days',
  policy: 'shield-check',
  public: 'globe',
  device_thermostat: 'thermometer',
  bolt: 'zap',
  attach_money: 'dollar-sign',
  check_circle: 'check-circle',
  dashboard: 'layout-dashboard',
  keep: 'pin',
  folder: 'folder',
  star: 'star',
  chat_bubble: 'message-circle',
  lock_person: 'lock',
};

// Maps a DB icon name to nav iconData: the lucide equivalent when mapped,
// otherwise the original name on the Material Symbols font.
export const resolveNavIconData = (
  materialName: string,
): { name: string; library?: IconLibrary } => {
  const lucideName = MATERIAL_TO_LUCIDE_NAME[materialName];

  return lucideName && lucideName in LUCIDE_ICONS
    ? { name: lucideName, library: 'lucide' }
    : { name: materialName };
};
